import React, { useState, useEffect } from "react";
import { Table, Spin, Alert } from "antd";
import "./table.scss";
import { getColumns } from "./mock";
import { CfoApi } from "src/services/cfo/cfo.api";
import { useDashboardStore } from "@pages/Dashboard/store/dashboard.state";
import { TableRowData, transformFinancialData } from "./utils";

export const PnlExpandableTable: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [tableData, setTableData] = useState<TableRowData[]>([]);
  const columns = getColumns();

  const { dateRange, asinSelected } = useDashboardStore();

  const fetchFinancialData = async () => {
    try {
      setLoading(true);
      setError(null);

      const startDate = dateRange.startDate.toISOString().split("T")[0];
      const endDate = dateRange.endDate.toISOString().split("T")[0];
      const asin = asinSelected[0] || "";

      const cfoApi = new CfoApi();

      // Make both API calls simultaneously
      const [financialData, totalSalesBreakdown] = await Promise.all([
        cfoApi.getFinancialData(startDate, endDate, asin),
        cfoApi.getTotalSalesBreakdown(startDate, endDate, asin),
      ]);

      // Transform data with breakdown included
      const transformedData = transformFinancialData(
        financialData,
        totalSalesBreakdown,
      );
      setTableData(transformedData);
    } catch (err) {
      console.error("Failed to fetch financial data:", err);
      setError("Failed to load financial data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFinancialData();
  }, [dateRange.startDate, dateRange.endDate, asinSelected]);

  return (
    <div className="pnl-expandable-table">
      {error && (
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      {loading ? (
        <div className="table-loading-container">
          <Spin size="large" />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={tableData}
          rowKey="key"
          pagination={false}
          scroll={{
            y: 600,
          }}
        />
      )}
    </div>
  );
};
